export default __webpack_public_path__ + "static/media/susilpic.ff9d35f7.jpeg";